module.exports = __webpack_public_path__ + "static/media/TRIAL 2 if-both-correct.a0ca6ae7.mp3";